declare var moment:any;

export class CommonUtil {

}

export function makeDateToString(type:String):string{
    let currentDate = new Date();
    let year = String(currentDate.getFullYear());
    let month = String(currentDate.getMonth()+1);
    let day = String(currentDate.getDate());

    if(String(month).length < 2){
        month = "0" + String(month); 
    }

    if(String(day).length < 2){
        day = "0" + String(day); 
    }
    if(type.indexOf("START") > -1){
        return year +  month + '01';
    }else{
        return year +  month + day;
    }
}

export function makeConditionUTCDate(type:string, strDate:string): string{
    let resultValue = "";
    let date = new Date();
    if(!strDate || strDate.length != 8){ 
        strDate = makeDateToString(type);
    }
    
    let year = Number(strDate.substr(0,4));
    let month = Number(strDate.substr(4,2));
    let day = Number(strDate.substr(6,2));
    let hour;
    let minute;
    let second;
    
    if(type.indexOf("START") > -1){
        hour = 0;
        minute = 0;
        second = 0;
    }else if(type.indexOf("END") > -1){
        hour = 23;
        minute = 59;
        second = 59;
    }
    date.setFullYear(year);
    date.setMonth(month);
    date.setDate(day);
    date.setHours(hour);
    date.setMinutes(minute);
    date.setSeconds(second);

    resultValue += date.getUTCFullYear();
    
    if(String(date.getUTCMonth()).length < 2){
        resultValue += "0";
        resultValue += date.getUTCMonth();
    }else{
        resultValue += date.getUTCMonth();
    }
    if(String(date.getUTCDate()).length < 2){
        resultValue += "0";
        resultValue += date.getUTCDate();
    }else{
        resultValue += date.getUTCDate();
    }
    if(String(date.getUTCHours()).length < 2){
        resultValue += "0";
        resultValue += date.getUTCHours();
    }else{
        resultValue += date.getUTCHours();
    }
    if(String(date.getUTCMinutes()).length < 2){
        resultValue += "0";
        resultValue += date.getUTCMinutes();
    }else{
        resultValue += date.getUTCMinutes();
    }
    if(String(date.getUTCSeconds()).length < 2){
        resultValue += "0";
        resultValue += date.getUTCSeconds();
    }else{
        resultValue += date.getUTCSeconds();
    }
    return resultValue;

}


// WEBPACK FOOTER //
// ./src/app/utils/common-util.ts